import { Box, Center, Image, Container } from "@chakra-ui/react";
import Banner from "../Nav/Banner"
import Acciones from "./Acciones";
import Carousel from "./Carousel";
import Metas from "./Metas";
import Zigrid from "./Zigrid";
import logo from './logo.jpg'
const ads = "https://blog.mailrelay.com/wp-content/uploads/2018/03/anuncios-publicitarios.png"

	

const Home = () => {
    return (
      
		<Box
            flexDir="row"
            alignItems="stretch"
            width="100%"
            display={{base: "block", lg: "flex"}}
            pt="2"
        >
			
            <BoxA/> {/*left box with add  */}
            <BoxB/>
            <BoxC/> {/*right box with add  */}
        </Box>
			
    );
}


const BoxA = () => {
    return  <Center
        flex="1"
        //bg="purple.300"
    >
        <Box
            bg="cyan.100"
            m="10"
        >
            <Image 
                alt="ad"
                src={logo}
            />
        </Box>
    </Center>
}

{/*main home box */}
const BoxB = () => {
    return <Container maxW="xl" centerContent> 

				<Box
			        mt="2%"
			        flex="3"
			        p="4"
					justifyContent="center"
					display="stretch" 
		    	>
		        
			        <Zigrid/>
			        <Acciones/>
			        <Metas/>
		    	</Box>
			</Container>
}

const BoxC = () => {
    return  <Center
        flex="1"
        //bg="purple.300"
    >
        <Box
            m="10"
            bg="cyan.100"
        >
            <Image 
                alt="ad"
                src={logo}
            />
        </Box>
    </Center>
}

export default Home;